import { render, staticRenderFns } from "./ProductPurchaseAction.vue?vue&type=template&id=055b9f04&"
import script from "./ProductPurchaseAction.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports